import { Tab, Tooltip } from '@mui/material';

const TooltipTab = (props) => {
  const { message, value } = props;

  if (message !== null)
    return (
      <Tooltip value={value} title={message} arrow>
        {
          // disabled tooltip hack https://github.com/mui/material-ui/issues/33182#issuecomment-2823321971
        }
        <span aria-label={undefined}>
          <Tab
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
            disabled
          />
        </span>
      </Tooltip>
    );
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Tab {...props} />
  );
};

export default TooltipTab;
